import React from 'react';
import { AI_FEATURE_CATEGORIES } from '~core/aiEdit/aiFeatureCategories';
import { showAiFeatureInfo } from '~core/aiEdit/aiIndividualHelp';
import AICard from './AICard';
import { router } from '~src/router';

const AIsPage = () => {
  return (
    <div className="ai-content">
      <section className="ai-hero">
        <div className="ai-hero__headline">
          <h1>Intelligenza Artificiale per il Settore Funebre</h1>
          <p className="ai-hero__sub">
            Strumenti su misura per le imprese funebri: restauro, correzioni e
            sfondi professionali.
          </p>
        </div>
        <div className="ai-hero__actions">
          <a
            href="/credits"
            className="ai-hero__cta ai-hero__cta--secondary"
            onClick={(e) => {
              e.preventDefault();
              router.navigate('/credits');
            }}
          >
            Crediti
          </a>
        </div>
      </section>

      <section className="ai-list">
        {AI_FEATURE_CATEGORIES.map((cat) => (
          <div key={cat.id} className="ai-category">
            <h2 className="ai-category__title">{cat.title}</h2>
            <div className="ai-grid g-grid g-grid-cards">
              {cat.features.map((f) => (
                <AICard
                  key={f.id}
                  title={f.title}
                  imageUrl={f.image}
                  onClick={() => showAiFeatureInfo(f.id)}
                />
              ))}
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default AIsPage;
